import classNames from 'classnames';
import React from 'react';

import Text, { TextProps } from './Text';

type Sub = string | number | null | undefined | false;

interface TextWithSubsProps extends TextProps {
  subs: Sub[];
  subClass?: string;
  width?: string;
}

/**
 * Same markup and styling as TextWithSub, but renders several stacked
 * sub-lines instead of one. Falsy entries are dropped, so callers can pass
 * conditional values directly (e.g. `compliesEudr && 'EUDR'`). PLA-971.
 */
const TextWithSubs: React.FC<TextWithSubsProps> = ({
  text,
  textClass,
  subs,
  subClass,
  dataCy,
  onClick,
  overflow,
  width,
}) => {
  const subClassnames = classNames('text-with-sub__sub', {
    [`${subClass}`]: subClass,
  });

  const visibleSubs = subs.filter(Boolean) as Array<string | number>;

  return (
    <div className='text-with-sub' data-cy={dataCy}>
      <Text
        text={text}
        textClass={textClass}
        onClick={onClick}
        width={width}
        title={text.toString()}
        overflow={overflow}
      />

      {visibleSubs.map((sub) => (
        <small
          key={sub}
          className={subClassnames}
          style={{ width: '100%' }}
          title={sub.toString()}
        >
          {sub}
        </small>
      ))}
    </div>
  );
};

export default TextWithSubs;
